<template>
  <div v-if="show" class="details">
    <div class="info" :class="{ inactive: !status }">
      <div class="d-flex title">
        {{ this.$t('lastTriggered') }}
      </div>
      <div class="d-flex">
        <p class="d-flex inner-text mr-1">
          {{ lastTriggeredDate }}
        </p>
        <span class="d-flex" style="font-size: 0.9em">
          {{
            lastTriggeredTime && lastTriggeredTime !== ''
              ? ` ${$t('at')} ` + lastTriggeredTime
              : 'NA'
          }}
        </span>
      </div>
    </div>
    <div class="vl"></div>
    <div class="info w-25" :class="{ inactive: !status }">
      <div class="d-flex title">
        {{ this.$t('createdOn') }}
      </div>
      <div class="d-flex">
        <p class="d-flex inner-text mr-1">
          {{ createdDate }}
        </p>
        <span class="d-flex" style="font-size: 0.9em">
          {{
            createdInfo && createdInfo !== ''
              ? ` ${$t('at')} ` + createdInfo
              : 'NA'
          }}
        </span>
      </div>
    </div>
    <div class="vl"></div>
    <div
      class="info w-15"
      :class="{ inactive: !status || !hasNotificationAccess }"
    >
      <div class="d-flex title">
        {{ this.$t('notificationChannels') }}
      </div>
      <div class="d-flex inner-text">
        <span
          :class="
            status && parseInt(notificationCount) > 0 && hasNotificationAccess
              ? 'hyperlink'
              : 'non-hyperlink'
          "
          @click="onShowNotificationChannelsEvent(rule)"
        >
          {{ notificationCount }}
        </span>
      </div>
    </div>
    <div class="vl"></div>
    <div class="info">
      <div class="d-flex title">
        {{ this.$t('status') }}
      </div>
      <div class="d-flex" v-if="!isUnderMaintenance">
        <RexToggle
          id="status"
          :label="labels"
          :isChecked="!status"
          :updateOnClick="false"
          @onChange="onStatusChange"
          :disabled="!hasAlertWritePermission"
        ></RexToggle>
      </div>
      <div class="" v-else>
        {{ $t('messageUnderMaintenance') }}
      </div>
    </div>
    <div class="vl"></div>
    <div class="info">
      <div class="d-flex title">
        {{ this.$t('action') }}
      </div>
      <div class="d-flex">
        <button
          v-if="hasAlertWritePermission"
          class="actions"
          :class="isUnderMaintenance && 'disabledIcon'"
        >
          <BaseIcon
            @click="isUnderMaintenance ? disabled : onEdit(rule)"
            class="mr-3"
            name="editFilled"
            width="1em"
            height="1.5em"
          />
        </button>
        <button
          v-if="hasAlertWritePermission"
          class="actions"
          :class="isUnderMaintenance && 'disabledIcon'"
        >
          <BaseIcon
            @click="isUnderMaintenance ? disabled : confirmDialog(deleteAction)"
            name="deleteFilled"
            width="1.2em"
            height="1.2em"
          />
        </button>
        <button
          v-if="!hasAlertWritePermission"
          class="actions"
          :class="isUnderMaintenance && 'disabledIcon'"
        >
          <BaseIcon
            @click="isUnderMaintenance ? disabled : onEdit(rule)"
            name="eyeFilled"
            width="1.6em"
            height="1.2em"
          />
        </button>
      </div>
    </div>
    <RexModalV3
      width="60rem"
      :title="modal.title"
      :show="delModal"
      @onClose="delModal = false"
      :enableFooter="true"
    >
      <template #body>
        <div class="alert-v2-modal-body">
          <div class="alert-info-row mt-2">
            <div>
              {{ modal.msg }}
            </div>
            &nbsp;
            <div
              class="inner-text"
              v-tooltip:top="{
                content: rule.ruleName,
                disabled: rule.ruleName.length < 20,
              }"
            >
              {{ rule.ruleName }}
            </div>
            &nbsp;
            <div>{{ $t('alert.alert-label') }}</div>
          </div>
        </div>
        <div class="d-flex flex-column mt-2 alert-info-lable">
          <RexInfoLabel
            v-if="isDeleteModelOpen"
            className="info-label"
            style="padding: 0.3rem 1rem 0rem 0.6rem; height: 2em"
            :multiColorProps="{ enableIcon: true, name: 'infoSM' }"
            :info="$t('actionCannotBeUndone')"
            :isMultiColor="true"
            :multiColorStyle="multiColorStyleForTaggedAlert"
          />
          <RexInfoLabel
            v-else-if="isActivation"
            className="info-label"
            style="padding: 0.3rem 1rem 0rem 0.6rem; height: 2em"
            :multiColorProps="{ enableIcon: true, name: 'infoSM' }"
            :info="$t('noLongerRecieveAlertNotifications')"
            :isMultiColor="true"
            :multiColorStyle="multiColorStyleForTaggedAlert"
          />
          <RexInfoLabel
            v-else
            className="info-label"
            style="padding: 0.3rem 1rem 0rem 0.6rem; height: 2em"
            :multiColorProps="{ enableIcon: true, name: 'infoSM' }"
            :info="$t('activateAlertEnableNotifications')"
            :isMultiColor="true"
            :multiColorStyle="multiColorStyleForTaggedAlert"
          />
        </div>
      </template>

      <template #footer>
        <div class="alert-del-footer-box">
          <div class="outerText_inactive" v-if="isDeleteModelOpen && status">
            <div class="inner-text_inactive">
              <div @click="inactiveInsteadDeleteRule" style="cursor: pointer">
                {{ $t('markInactiveAlert') }}
              </div>
            </div>
          </div>

          <div class="d-flex">
            <RexButtonV3
              variant="primary"
              @onClick="delModal = false"
              id="cancel"
            >
              {{ $t('cancel') }}
            </RexButtonV3>

            <RexButtonV3
              style="width: 120%"
              variant="default"
              @onClick="submitForm(modal)"
              id="submit"
              class="modalFootCol"
              :loading="loading"
            >
              {{ modal.submitButtonLabel }}
            </RexButtonV3>
          </div>
        </div>
      </template>
    </RexModalV3>
  </div>
</template>

<script>
/**
 * Displayed on an Component which does not have any data
 */
import RexToggle from '@/rex-components/RexToggle.vue';
import BaseIcon from '@/rex-components/BaseIcon.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { notificationSucess, notificationError } from '@/utils/notification';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import { usePermissions } from '@/hooks/usePermissions';
import { NOTIFICATION_RESOURCE_GROUP } from '@/router/constant';

export default {
  name: 'AlertInfo',
  components: {
    RexToggle,
    BaseIcon,
    RexModalV3,
    RexButtonV3,
    RexInfoLabel,
  },
  props: {
    lastTriggered: {
      type: String,
      default: '',
    },
    createdOn: {
      type: String,
      default: '',
    },
    notificationCount: {
      type: Number,
      default: 0,
    },
    status: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
    rule: {
      type: Object,
      default: null,
    },
    isUnderMaintenance: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      multiColorStyleForTaggedAlert: {
        color: '#F59600',
        'font-weight': 'bold',
      },
      labels: [this.$t('active'), this.$t('inactive')],
      createdDate: '',
      createdInfo: '',
      lastTriggeredDate: '',
      lastTriggeredTime: '',
      delModal: false,
      deleteAction: {},
      statusAction: {},
      isActivation: false,
      isDeleteModelOpen: false,
      modal: {
        type: '',
        title: '',
        msg: '',
        submitButtonLabel: '',
      },
      actionType: '',
      selectedStatus: false,
      loading: false,
    };
  },
  computed: {
    ...mapState('alertV2State/configure', ['alertActions']),
    ...mapGetters('alertV2State/configure', ['getCurrentAlertApplication']),
    hasAlertWritePermission() {
      const { hasCurrentServiceAlertWritePermission } = usePermissions();
      return hasCurrentServiceAlertWritePermission(
        this.getCurrentAlertApplication,
      );
    },
    hasNotificationAccess() {
      const { hasCapabilityPermission } = usePermissions();

      return hasCapabilityPermission(NOTIFICATION_RESOURCE_GROUP);
    },
  },
  mounted() {
    this.deleteAction = {
      type: this.alertActions['DEL'],
      title: this.$t('deleteAlert'),
      msg: this.$t('deleteAlertConfirm'),
      submitButtonLabel: this.$t('delete'),
      successMsg: this.$t('alertDeleted'),
      errorMsg: this.$t('deletionError'),
    };
    this.statusAction = {
      type: this.alertActions['STATUS'],
      title: this.$t('inactivateAlert'),
      msg: this.$t('inactivateAlertConfirm'),
      submitButtonLabel: this.$t('inactivateLabel'),
      successMsg: this.$t('inactivateSuccess'),
      errorMsg: this.$t('inactivateError'),
    };
    [this.createdDate, this.createdInfo] =
      this.createdOn && this.createdOn.split('at');
    [this.lastTriggeredDate, this.lastTriggeredTime] =
      this.lastTriggered && this.lastTriggered.split('at');
    this.selectedStatus = this.status;
  },
  methods: {
    ...mapActions('alertV2State/configure', [
      'deleteAlertRule',
      'updateAlertRule',
      'reloadConfiguredAlerts',
    ]),
    ...mapMutations('alertV2State/configure', [
      'setShowEditConfigureAlert',
      'setCurrentEditConfigureAlert',
      'setTotalNotificationChannelIdsTagged',
      'setShowTotalNotificationChannelsTagged',
    ]),
    inactiveInsteadDeleteRule() {
      this.delModal = false;
      this.onStatusChange(true);
    },
    onStatusChange(updatedStatus) {
      if (!this.status === updatedStatus) return;
      this.selectedStatus = updatedStatus;
      let updateMsg = this.getStatusUpdateResponseMsg(updatedStatus);
      this.statusAction.successMsg = updateMsg.successMsg;
      this.statusAction.errorMsg = updateMsg.errorMsg;
      if (updatedStatus) {
        this.confirmDialog(this.statusAction);
        this.isActivation = true;
      } else {
        this.confirmDialog(this.statusAction);
        this.statusAction.msg = this.$t('confirmationAlertRuleActivate');
        this.statusAction.submitButtonLabel = this.$t('activate');
        this.statusAction.title = this.$t('activateAlert');
        this.isActivation = false;
        // this.submitForm(this.statusAction);
      }
    },
    onEdit(editAction) {
      this.setCurrentEditConfigureAlert(editAction);
      this.setShowEditConfigureAlert(true);
    },
    onShowNotificationChannelsEvent(editAction) {
      if (
        editAction.active &&
        editAction.channels.length > 0 &&
        this.hasNotificationAccess
      ) {
        this.setTotalNotificationChannelIdsTagged(editAction.channels);
        this.setShowTotalNotificationChannelsTagged(true);
      }
    },
    getStatusUpdateResponseMsg(newStatus) {
      let statusMsg = {
        successMsg: newStatus
          ? this.$t('inactivateSuccess')
          : this.$t('activateSuccess'),
        errorMsg: newStatus
          ? this.$t('inactivateError')
          : this.$t('activateError'),
      };
      return statusMsg;
    },
    confirmDialog(action) {
      this.modal = action;
      this.delModal = true;
      if (action.type === 'DEL') {
        this.isDeleteModelOpen = true;
      } else this.isDeleteModelOpen = false;
    },
    async submitForm(action) {
      this.loading = true;
      if (!(this.rule || this.rule.ruleId)) {
        notificationError(this.$t('errorText'));
        return;
      }
      try {
        if (action.type === this.alertActions.DEL) {
          await this.deleteAlertRule(this.rule.ruleId);
        } else {
          let params = {
            ...this.rule,
            ...{ active: !this.selectedStatus },
          };
          await this.updateAlertRule(params);
        }
        notificationSucess(action.successMsg);
      } catch (err) {
        notificationError(action.errorMsg);
      } finally {
        this.reloadConfiguredAlerts(true);
        this.delModal = false;
        this.loading = false;
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.no-data-icon {
  width: 100%;
}
.details {
  // border-top: 1px solid black;
  width: 100%;
  display: flex;
  align-items: center;
  //   align-items: center;
  //   text-align: center;
  //   height: 100%;
}
span {
  padding: 2px;
}
.inner-text {
  font-family: $semi-bold;
  font-size: 1em;
  color: $color-brand-accent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 13em;
}
.info {
  width: 20%;
}
.vl {
  border-left: 1px solid rgb(112, 112, 112);
  height: 50px;
  margin-right: 20px;
}
.title {
  margin-bottom: 4px;
}
p {
  margin-bottom: auto;
}
.alert-info-row {
  @include flex-center-vert;
  margin-right: auto;
  margin-left: auto;
}
.modalFootCol {
  padding-left: 0.625em;
}
.actions {
  @include btn-reset;
  fill: $color-brand-accent;
}
.inactive {
  opacity: 0.6 !important;
}
.hyperlink {
  text-decoration: underline;
  cursor: pointer;
}
.non-hyperlink {
  text-decoration: none;
  cursor: not-allowed;
}
.alert-info-lable {
  margin-top: 5px !important;
  background: #3c3d40;
  color: #f59600;
  border-radius: 0.4rem;
}
.mFooter {
  margin: 0.12rem !important;
}

.outerText_inactive {
  display: flex;
  align-content: space-between;
  flex-direction: column;
  justify-content: center;
}
.inner-text_inactive {
  display: flex !important;
  font-family: $regular;
  color: $color-brand-accent;
  justify-content: flex-end;
  text-decoration: underline;
}
.alert-del-footer-box {
  @include flex-center-justify(space-between);
}
.d-flex {
  display: flex;
}
.disabledIcon {
  cursor: not-allowed;
  pointer-events: none;
  fill: rgb(101, 101, 101);
}
</style>
